var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.type
    ? _c("span", { staticStyle: { "font-size": "bold", color: "#000" } }, [
        _vm._v(_vm._s(_vm.value)),
      ])
    : _vm.type === "money"
    ? _c("span", { staticStyle: { "font-size": "bold", color: "#000" } }, [
        _vm._v(_vm._s(_vm._f("formatAmount")(_vm.value))),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }